/** Readers for the code-set artifact fields a frame or a history block may
 *  carry. Shared by the streaming reducer and history hydration so a reload
 *  renders the card exactly as the live stream did. Each returns `{}` when
 *  the field is absent or malformed, so a part without it keeps its shape
 *  (and the card falls back to today's behaviour). */
import type { ArtifactTablePreview } from "./types";

export function readExportFormats(raw: unknown): { export_formats?: string[] } {
  if (!Array.isArray(raw) || !raw.every((f) => typeof f === "string")) return {};
  return { export_formats: raw as string[] };
}

export function readTablePreview(raw: unknown): { preview?: ArtifactTablePreview } {
  if (!raw || typeof raw !== "object") return {};
  const p = raw as Record<string, unknown>;
  if (
    !Array.isArray(p.header) ||
    !Array.isArray(p.rows) ||
    !p.rows.every(Array.isArray) ||
    typeof p.total_rows !== "number"
  ) {
    return {};
  }
  return {
    preview: {
      header: p.header,
      rows: p.rows as unknown[][],
      total_rows: p.total_rows,
      ...(typeof p.row_label === "string" ? { row_label: p.row_label } : {}),
    },
  };
}
